module.exports = __webpack_public_path__ + "img/02d.4dc8014e.png";